export const dismissalTypeOptions = [
	{
		value: '1',
		name: 'Zaměstnavatel',
	},
	{
		value: '2',
		name: 'Dohodou (vážné důvody dle § 5c)',
	},
	{
		value: '3',
		name: 'Dohodou (bez vážných důvodů dle § 5c)',
	},
	{
		value: '4',
		name: 'zaměstnanec (vážné důvody dle § 5c)',
	},
	{
		value: '5',
		name: 'zaměstnanec (bez vážných důvodů dle § 5c)',
	},
	{
		value: '6',
		name: 'zaměstnavatel pro hrubé porušení prac. kázně',
	},
];
